import { render, staticRenderFns } from "./CreateEvent.vue?vue&type=template&id=18d59d45"
import script from "./CreateEvent.vue?vue&type=script&lang=js"
export * from "./CreateEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports